import { useState } from "react";
import { BookOpen, Eye, Clock, Trophy, ChevronDown } from "lucide-react";

const ITEMS = [
  {
    id: "view",
    icon: Eye,
    title: "Result Kaise Dekhein",
    body: (
      <>
        Har <b>15 minute</b> mein naya result upar ke 3 boxes mein live update hota hai —
        Jackpot Royal, Golden aur Aakhri Dao. Puri history niche chart mein dekhein.
      </>
    ),
  },
  {
    id: "timing",
    icon: Clock,
    title: "Result Timing",
    body: (
      <>
        Draws chalte hain <b>9:00 AM se 9:00 PM (IST)</b> tak, har <b>15 minute</b> par.
        Kul <b>49 slots</b> roz — 09:00 AM se 09:00 PM tak continuous.
      </>
    ),
  },
  {
    id: "play",
    icon: Trophy,
    title: "How to Play",
    body: (
      <>
        Countdown timer se pata karein next draw kab hai, live result dekhein aur apne
        pichhle results ka chart search karke verify karein.
      </>
    ),
  },
];

export default function HowToPlay() {
  const [sectionOpen, setSectionOpen] = useState(false);
  const [openItem, setOpenItem] = useState(null); // id or null

  const toggleItem = (id) => setOpenItem((cur) => (cur === id ? null : id));

  return (
    <section className="hiw" data-testid="how-to-play-section">
      <button
        type="button"
        className={`hiw-head ${sectionOpen ? "is-open" : ""}`}
        aria-expanded={sectionOpen}
        aria-controls="hiw-panel"
        onClick={() => setSectionOpen((v) => !v)}
        data-testid="hiw-toggle"
      >
        <BookOpen className="hiw-head-icon" size={16} />
        <span className="hiw-head-label">How It Works</span>
        <ChevronDown
          className={`hiw-chevron ${sectionOpen ? "is-open" : ""}`}
          size={16}
        />
      </button>

      <div
        id="hiw-panel"
        className={`hiw-panel ${sectionOpen ? "is-open" : ""}`}
        role="region"
        aria-hidden={!sectionOpen}
      >
        <div className="hiw-panel-inner">
          {ITEMS.map(({ id, icon: Icon, title, body }) => {
            const isOpen = openItem === id;
            return (
              <div
                key={id}
                className={`hiw-item ${isOpen ? "is-open" : ""}`}
                data-testid={`hiw-item-${id}`}
              >
                <button
                  type="button"
                  className="hiw-item-head"
                  aria-expanded={isOpen}
                  onClick={() => toggleItem(id)}
                  data-testid={`hiw-item-toggle-${id}`}
                >
                  <span className="hiw-item-icon-wrap">
                    <Icon size={14} strokeWidth={2.2} className="hiw-item-icon" />
                  </span>
                  <span className="hiw-item-title">{title}</span>
                  <ChevronDown
                    className={`hiw-chevron hiw-chevron--sm ${isOpen ? "is-open" : ""}`}
                    size={14}
                  />
                </button>
                <div className={`hiw-item-body ${isOpen ? "is-open" : ""}`}>
                  <p>{body}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
